<template>
    <div class="productListWrapInner">
        <div class="searchBox">
            <div class="left">
                <el-form :inline="true">
                    <el-form-item style="width: 200px;">
                        <el-input  style="width: 200px;" placeholder="款号/商品名称/公司/品牌" v-model="fuzzyQuery" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="right">
                <el-form :inline="true">
                    <el-form-item>
                        <el-select placeholder="请选择公司" v-model="currentSelectCompany" @change="changeCompany" >
                            <el-option label="所有公司" value=""></el-option>
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in companyWord" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-select placeholder="请选择品牌" v-model="currentSelectBrand"  @change="changeBrand">
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in brandWprd" :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item>
                        <el-button type="primary" @click="toAddGoods" v-if="function_addProduct">添加商品</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="uploadGoodsBatch"  v-if="function_addProduct">批量上传</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="downLoadExcel(1)">下载表格</el-button>
                    </el-form-item>
                    <el-form-item>
                       <el-button type="success" @click="downLoadErweiMa">批量下载二维码</el-button>
                    </el-form-item>
                </el-form>
            </div>
            
        </div>
        <div class="tableBox">
            <el-table v-loading="isLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" ref="multipleTable" border stripe :data="tableData"
                tooltip-effect="dark" style="width: 100%" >
                <el-table-column type="selection" width="35">
                </el-table-column>
                <el-table-column label="序号" width="40">
                    <template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
                </el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <div class="imgBox">
                             <img :src="IMG_PREV+scope.row.imageFile" alt="" class="imgThump">
                        </div>
                       
                    </template>
                </el-table-column>
                <el-table-column label="商品名称">
                    <template slot-scope="scope">{{ scope.row.itemName }}</template>
                </el-table-column>
                <el-table-column label="商品ID">
                    <template slot-scope="scope">{{ scope.row.itemUnqueNumber }}</template>
                </el-table-column>
                <el-table-column label="款号">
                    <template slot-scope="scope">{{ scope.row.styleNumber }}</template>
                </el-table-column>
                <el-table-column label="颜色" width="40">
                    <template slot-scope="scope">{{ scope.row.colorName }}</template>
                </el-table-column>
                <el-table-column label="尺码">
                    <template slot-scope="scope">{{ scope.row.sizeNames }}</template>
                </el-table-column>
                <el-table-column label="公司"  >
                    <template slot-scope="scope">{{ scope.row.companyName }}</template>
                </el-table-column>
                <el-table-column label="品牌" >
                    <template slot-scope="scope">{{ scope.row.brandName }}</template>
                </el-table-column>
                <el-table-column label="收藏人数" width="40">
                    <template slot-scope="scope">{{ scope.row.collectNum }} 人 </template>
                </el-table-column>
                <el-table-column label="订货价" >
                    <template slot-scope="scope">{{ scope.row.orderPrice }} 元 </template>
                </el-table-column>
                <el-table-column label="加购数量" width="40">
                    <template slot-scope="scope">{{ scope.row.cartCount }} 件 </template>
                </el-table-column>
                <el-table-column label="销量" width="40">
                    <template slot-scope="scope">{{ scope.row.checkoutCount }} 件 </template>
                </el-table-column>
                <el-table-column label="销售额" >
                    <template slot-scope="scope">{{ scope.row.checkoutAmount }} 元 </template>
                </el-table-column>
                <el-table-column label="操作"  width="170">
                    <template slot-scope="scope">
                        <div style="text-align: cen;">
                            <span class="spanBtn" @click='toEdit(scope.row)' v-if="function_editProduct">编辑</span>
                            <span class="spanBtn" @click="toDetail(scope.row)">详情</span>
                            <div class="switchBox" v-if="function_changeProductOnshelf">
                              <span v-if="scope.row.itemState==1" class="blue">上架中</span>
                              <span v-if="scope.row.itemState==2" style="color:#aaa">已下架</span>
                              <el-switch   v-model="scope.row.isOnShelf"    @change="toggleShelf(scope.row)"></el-switch>
                              
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page"
                :page-size.sync="num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {        json,       wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,api    } from '@/common/request.js'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                conferenceId:'',
                isLoading:false,
                tableData:[],
                //查询条件
                fuzzyQuery:'',
                page: 1,
                num: 10,
                currentSelectCompany:'',
                currentSelectBrand:'',
                searchObj:{},//最终组装好的搜索条件
                
                total:0,
                companyWord:[],
                brandWprd:[],
            }
        },
        components: {
        },
        computed: {
            function_addProduct(){
                return utils.getCurrentFunction().indexOf("addProduct")>-1
            },
            function_editProduct(){
                return utils.getCurrentFunction().indexOf("editProduct")>-1
            },
            function_changeProductOnshelf(){
                return utils.getCurrentFunction().indexOf("changeProductOnshelf")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },
            userTypeOptions() {
                return wordData.user_type
            },
            authResultOptions() {
                return wordData.auth_result
            },
            adminId(){
                return utils.getAdminId()
            }
            
        },
        methods: {
            changeBrand(){
                //查询表格
                let _this=this
                _this.page = 1
                console.log(1111)
                _this.getTableLists()
            },
            changeCompany(){
                let _this=this
                _this.currentSelectBrand=''
                _this.brandWprd=[]
                let arg={
                    conferenceId:_this.conferenceId,
                    userId:_this.currentSelectCompany,
                }
                //获取公司下的品牌
                ajaxPost('/admin/brandlist', arg).then(function(res) {
                    if(res.errorCode==200){
                        let resData=res.data?res.data:[]
                        _this.brandWprd=resData.map(function(item,index){
                            let buffer={
                                text:item.brandName,
                                value:item.brandId,
                            }
                            return buffer
                        })
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
                //查询表格
                _this.page = 1
                _this.getTableLists()
            },
            getCompanyOption(){
                let _this=this
                let arg={
                    conferenceId:_this.conferenceId,
                }
                ajaxPost('/admin/companylist', arg).then(function(res) {
                    if(res.errorCode==200){
                        let resData=res.data?res.data:[]
                        _this.companyWord=resData.map(function(item,index){
                            let buffer={
                                text:item.companyName,
                                value:item.userId,
                            }
                            return buffer
                        })
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            uploadGoodsBatch(){
               let _this=this
               this.$router.push({name: 'activeInnerProductAddBatch',params: { conferenceId:_this.conferenceId}})
            },
            refreshPage(){
                this.getTableLists()
            },
            downLoadExcel(type){
                let _this=this
                let arg={
                    adminId:_this.adminId,
                    conferenceId:_this.conferenceId,
                    type:type
                }
                ajaxPost('/file/exportHttp', arg).then(function(res) {
                    if(res.errorCode==200){
                        _this.$message("下载成功")  
                    
                        let url=res.data
                        window.location.href= _this.IMG_PREV+url
                        
                    }else{
                        _this.$message(res.errorMsg)
                    }
                }, function(res) {
                
                })
            },
            downLoadErweiMa(){
                let _this=this
                let arg={
                    // userId:'',
                    conferenceId:_this.conferenceId,
                    colorIds:-1//多个颜色id 用,隔开  全选传-1
                }
                ajaxPost('/file/downloadQRcode', arg).then(function(res) {
                    let url=res.data
                    let newUrl=url.slice(6)
                    window.open(_this.IMG_PREV+newUrl,"_blank")
                }, function(res) {
                
                })
            },
            toggleShelf(list){
                 // console.log(list)  
                let _this=this
                let tipText=''
                 let state=''
                if(list.itemState==1){
                    state=2
                    tipText="确认下架该商品吗？"
                }
                if(list.itemState==2){
                    state=1
                     tipText="确认上架吗？"
                }
                if(!confirm(tipText)){
                    setTimeout(function(){
                        list.isOnShelf=!list.isOnShelf
                    },50)
                    
                    return false
                }
              
              let arg={
                  "conferenceId":_this.conferenceId,
                  "itemUniqueNumber":list.itemUnqueNumber,
                  "state":state
              }
              ajaxPost('/admin/updateShelfObtained', arg).then(function(res) {
                  if(res.errorCode==200){
                    _this.refreshPage()
                  }
              }, function(res) {
              
              })
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
            },
            toAddGoods(){
                let _this=this
              this.$router.push({name: 'activeInnerProductAdd',params: { conferenceId:_this.conferenceId}})
            },
            fuzzySearchClick() {
                this.searchObj = {
                    fuzzyQuery: this.fuzzyQuery,
                    num: this.num,
                    page: 1,
                }
                this.getTableLists()
            },
            multiSearchClick() {
                this.searchObj = {
                    num: this.num,
                    page: 1,
                }
                this.getTableLists()
            },
            handleSizeChange(size) { //分页：每页n条
                this.num = size
                this.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.page = page
                this.getTableLists()
            },
            getTableLists(){
                let _this=this
                _this.isLoading=true
                
                _this.searchObj={
                    num:_this.num,
                    page:_this.page,
                    fuzzyQuery:_this.fuzzyQuery,
                    userId:_this.currentSelectCompany,
                    brandId:_this.currentSelectBrand,
                }
                
                let arg=JSON.parse(JSON.stringify(_this.searchObj))
                arg.conferenceId=_this.conferenceId
                ajaxPost('/admin/getitemList', arg).then(function(res) {
                    
                    if(res.data.reviewList){
                        _this.tableData=res.data.reviewList.map(function(item,index){
                            if(item.itemState==1){
                                item.isOnShelf=true
                            }else{
                                item.isOnShelf=false
                            }
                             return item
                        })
                       
                    }
                    _this.total=parseInt(res.data.total) 
                    _this.customerTotal=res.data.total
                    _this.isLoading=false
                }, function(res) {
                    _this.isLoading=false
                })
            },
            toDetail(list) {
                let _this=this
                console.log(list)
                this.$router.push({name: 'activeInnerProductDetail',params: { itemUniqueNumber: list.itemUnqueNumber,conferenceId:_this.conferenceId }})
            },
            toEdit(list) {
                let _this=this
                console.log(list)
                this.$router.push({name: 'activeInnerProductEdit',params: { itemUniqueNumber: list.itemUnqueNumber,conferenceId:_this.conferenceId }})
            },
            
        },
        mounted(){
           this.getParams()
           this.getTableLists()
           this.getCompanyOption()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
    // *{outline: 1px solid blue;}
    .productListWrapInner {
       background: #fff;
       .imgBox{
           height: 80px;
           .imgThump{max-height:100%;}
       }
      
       .right .el-form--inline .el-form-item{margin-right: 0px; max-width: 150px;}
       .searchBox {
           padding: 0.25rem 0.25rem 0;
       
           .left {
               float: left;
           }
       
           .right {
             float:right;
           }
       }
       
       .searchBox:after {
           content: "";
           display: block;
           clear: both;
       }
       
       .tableBox {
           padding: 0.25rem;
           .switchBox{display: inline-block;}
       }
       .el-table .cell{font-size: 12px;padding:2px;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/product.vue